import { Routes as Switch, Route, Navigate } from 'react-router-dom';
import { asParentPath } from '../../utils/as-parent-path';
import { AppRouteProps, AppRoutes } from '../../utils/app-routes';
import { MarketingPage } from '../../../marketing/modules/common/components/marketing-page/marketing-page';
import { AccountsManagementPage } from '../../../accounts-management/components/accounts-management-page/accounts-management-page';
import { FleetPage } from '../../../fleet/modules/components/fleet-page/fleet-page';

export const Routing = () => (
    <Switch>
        <Route
            element={<AccountsManagementPage />}
            path={asParentPath(AppRouteProps[AppRoutes.AccountsManagement].path)}
        />
        <Route
            element={<MarketingPage />}
            path={asParentPath(AppRouteProps[AppRoutes.Marketing].path)}
        />
        <Route element={<FleetPage />} path={asParentPath(AppRouteProps[AppRoutes.Fleet].path)} />
        <Route
            path="*"
            element={<Navigate to={AppRouteProps[AppRoutes.AccountsManagement].path} replace />}
        />
    </Switch>
);
